import PropTypes from 'prop-types'

export default function Spinner({ size = 24, color = 'var(--color-blue)' }) {
  return (
    <div
      style={{
        width: size,
        height: size,
        border: `3px solid var(--color-border)`,
        borderTopColor: color,
        borderRadius: '50%',
        animation: 'spin 0.7s linear infinite',
        flexShrink: 0,
      }}
    />
  )
}

Spinner.propTypes = {
  size: PropTypes.number,
  color: PropTypes.string,
}